export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface ProductTypeBreakdown {
  [productType: string]: {
    count: number;
    percentage: number;
  };
}

export interface InteractionMetrics {
  textBasedInteractions: number;
  voiceToVoiceInteractions?: number;
  totalInteractions?: number;
  uniqueUsers: number;
  averageInteractionsPerUser: number;
  imageInteractions?: number;
  imageInteractionsRate?: number;
  dateRange: DateRange;
  productTypeBreakdown?: ProductTypeBreakdown;
}

// Default analytics structure (when no custom dates are provided)
export interface DefaultAnalyticsData {
  lastDay: InteractionMetrics;
  lastWeek: InteractionMetrics;
}

// Custom date range analytics structure (when custom dates are provided)
export interface CustomAnalyticsData extends InteractionMetrics {}

// Union type to handle both scenarios
export type AnalyticsData = DefaultAnalyticsData | CustomAnalyticsData;

// Type guard to check if data is default analytics
export function isDefaultAnalyticsData(
  data: AnalyticsData
): data is DefaultAnalyticsData {
  return 'lastDay' in data && 'lastWeek' in data;
}

// Type guard to check if data is custom analytics
export function isCustomAnalyticsData(
  data: AnalyticsData
): data is CustomAnalyticsData {
  return 'textBasedInteractions' in data && !('lastDay' in data);
}
